<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script setup>
import { onMounted, onBeforeUnmount, nextTick, watch, computed } from "vue";
import { useLinkStore } from "@/stores/linkStore";
import { useAuthStore } from "@/stores/authStore";
import { useUploadStore } from "@/stores/uploadStore";
import { useRouter } from "vue-router";

const linkStore = useLinkStore();
const authStore = useAuthStore();
const uploadStore = useUploadStore();
const router = useRouter();

// ユーザー種別
const userType = computed(() => authStore.userSettings.user_type);

// 各ブランドのfavicon
const taitockFaviconSrc = new URL("@/assets/TaiTock_fabicon.png", import.meta.url).href;
const qumowillFaviconSrc = new URL("@/assets/qumowill_favicon.png", import.meta.url).href;

// favicon・タイトルを動的に切り替え
function updateBranding(type) {
  const path = location.pathname;
  const isTaitock = type === 'taitockeye' || path.indexOf('/taitock') === 0;
  const isQumowill = type === 'qumowill' || path.indexOf('/qumowill') === 0;
  const link = document.querySelector("link[rel='icon']");
  if (link) {
    if (isTaitock) {
      link.href = taitockFaviconSrc;
    } else if (isQumowill) {
      link.href = qumowillFaviconSrc;
    } else {
      link.href = "/Poranos_favicon.png";
    }
  }
  if (isQumowill) {
    document.title = 'Qumowill AI マニュアル';
  } else {
    document.title = 'Poranos Manager';
  }
}

// userSettingsの変更を監視
watch(userType, (newVal) => {
  updateBranding(newVal);
}, { immediate: true });

function handleKeydown(e) {
  if (e.repeat) return; // ✅ 押しっぱなしを無視
  // 入力中の input/textarea などでは無効にする
  const tag = document.activeElement?.tagName;
  const isInputField = ["INPUT", "TEXTAREA"].includes(tag);
  const isContentEditable = document.activeElement?.isContentEditable;

  if (isInputField || isContentEditable) return;

  console.log("isLinking =", linkStore.isLinking);
  console.log("isLinking.value =", linkStore.isLinking?.value);

  if (!linkStore.isLinking) {
    console.warn("⚠️ Unityがリンクされていません。位置合わせは無効です。");
    return;
  }

  if (e.code === "Enter") {
    const currentPath = router.currentRoute.value.fullPath;
    if (currentPath.startsWith("/anchor")) return; // 🔁 anchor中は無視

    router.push({
      path: "/anchor",
      query: { returnTo: currentPath },
    });
  }

  // if (e.code === "Enter") {
  //   const returnTo = router.currentRoute.value.fullPath;
  //   router.push({
  //     path: "/anchor",
  //     query: { returnTo },
  //   });
  // }
}

// アップロード進行中にリロード / タブクローズしようとしたらブラウザ警告を出す
// (ハードリロードは JS ランタイム破棄 → upload abort なので誤操作防止)
// docs/engineering/MANUAL_VIDEO_NORMALIZATION_PLAN.md
function handleBeforeUnload(e) {
  if (uploadStore.hasActiveUploads) {
    // 多くのモダンブラウザはカスタムメッセージを無視して既定文言を表示するが、
    // returnValue を設定することで dialog が出る
    e.preventDefault();
    e.returnValue = "アップロードが進行中です。本当に閉じますか？";
    return e.returnValue;
  }
}

onMounted(() => {
  // ✅ linkStoreの初期化後にイベント登録するよう保証
  nextTick(() => {
    window.addEventListener("keydown", handleKeydown);
  });
  window.addEventListener("beforeunload", handleBeforeUnload);
});

onBeforeUnmount(() => {
  window.removeEventListener("keydown", handleKeydown);
  window.removeEventListener("beforeunload", handleBeforeUnload);
});
</script>

<style>
html,
body,
#app {
  height: 100%;
}

/* 印刷用グローバルスタイル */
@media print {
  /* NavigationDrawerを非表示 */
  .v-navigation-drawer {
    display: none !important;
  }

  /* AppBar: ロゴ以外を非表示 */
  .v-app-bar .v-spacer,
  .v-app-bar .v-btn,
  .v-app-bar .user-name,
  .v-app-bar .v-menu {
    display: none !important;
  }

  /* AppBarの背景をシンプルに */
  .v-app-bar {
    background: white !important;
    box-shadow: none !important;
    position: relative !important;
  }

  /* ロゴは表示 */
  .v-app-bar .v-app-bar-title {
    display: block !important;
  }

  /* ロゴのリンク色を黒に */
  .v-app-bar .v-app-bar-title a {
    color: black !important;
  }
}
</style>
